import { getProtocols } from '../../api/fullyused'

export default {
  "upsert": "full",
  'entityName': 'fullyused',
  // "title": "Site request",
  "pagination": {
    "itemsPerPage": 5,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      small: true,
      list: (entity, search) => getProtocols(search),
      filter: () => ({ status: ['INIT', 'CONFIRMED', 'ACTIVE'] }),
      "title": "name",
      validators: ['required']
    },
    {
      "value": "_site_id1",
      "reference": "protocol_has_site",
      "text": "Site",
      small: true,
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "site.name",
      "id": "site_id",
      "subtitle": item => `${item.site.city} - ${item.site.code}`,
      deps: ['protocol_id'],
      readonly: item => !item.protocol_id,
      filter: (item, search) => {
        if (!search) {
          return { protocol_id: item.protocol_id }
        }
        return {
          protocol_id: item.protocol_id, 'site.name': [{ 'site.name': `%${search}%` },
          { 'site.city': `%${search}%` }, { 'site.code': `%${search}%` }]
        }
      },
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
      validators: ['required']
    },
    {
      "value": "_site_id2",
      reference: 'monitor',
      "text": "Site",
      id: 'site_id',
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "site.name",
      subtitle: item => `${item.site.city} - ${item.site.code}`,
      deps: ['protocol_id'],
      readonly: item => !item.protocol_id,
      filter: (item, search) => {
        if (!search) {
          return  { protocol_id: item.protocol_id }
        }
        return { 'site.name': [{ 'site.name': `%${search}%`},
        {'site.city': `%${search}%`}, {'site.code': `%${search}%`}], protocol_id: item.protocol_id }
      },            
      visible: (item, state) => state.user.role === 'Monitor',
    },
    {
      value: "site_id",
      deps: ['_site_id1', '_site_id2'],
      default: item => item._site_id1 ?? item._site_id2,
      type: 'hidden'
    },    
    {
      value: 'labels',
      text: 'Labels',
      small: true,
      hint: 'Check on secondary labelling or lost/destroyed labels',
      type: 'switch',
      deps: ['protocol_id'],
      visible: (item, state, _value, selected) => selected && selected.has_labels
    },
    {
      text: 'Request Date',
      value: 'request_date',
      type: 'hidden',
      table: true,
    },
    {
      text: 'Status',
      value: 'status',
      type: 'list',
      table: true,
      visible: false
    }
  ],
}
